// work data

export const Work = [
    {
        id:1,
        name:"Weather App",
        description:" A simple weather app to get weather report of your area.",
        tags:["react","express","open-weather"],
        
        demo:"https://tanmayweatherapp.herokuapp.com/",
        github:"https://github.com/ktsrivastava29/weatherApp"
    },
    {
        id:2,
        name:"Vasuri",
        description:"It is a social media app made using flutter and firebase!.",
        tags:["firebase","flutter"],
        
        demo:"https://docs.google.com/uc?export=download&id=1Ii-tAOr0BAWhnPWPAGtbz17P8dsvsNRA",
        github:"https://github.com/ktsrivastava29/vasuri"
        
    },
    // {
    //     id:3,
    //     name:"Dev.to Clone",
    //     description:"A clone of Dev.to build using ReactJS. With realtime fetching of articles from dev.to using API.",
    //     tags:["react","api","sass"],
        
    //     demo:"http://devto-clone-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/devto-clone"
    // },
    // {
    //     id:4,
    //     name:"Sidebar Menu",
    //     description:"A cool looking sidebar menu build using ReactJS and styledComponents.It has really smooth animations.",
    //     tags:["react","styledComponents","react-router"],
        
    //     demo:"https://react-sidebar.vercel.app/",
    //     github:"https://github.com/codebucks27/react-sidebar"
       
    // },{
    //     id:5,
    //     name:"Todo App(React + Redux)",
    //     description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
    //     tags:["react","redux","framer-motion"],
        
    //     demo:"http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/React-Redux-Todo-App"
        
    // },
    // {
    //     id:6,
    //     name:"Responsive Navigation Menu",
    //     description:"A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
    //     tags:["react","react-router","css"],
        
    //     demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/React-responsive-navbar"
        
    // },
    
  
] 